import { ADD_ONE_SIGNAL_TAGS, CREATE_ONE_SIGNAL_USER } from '../../state/mutations/User';
import {OneSignal} from 'react-native-onesignal';
import { addTagsMobile } from './addTag';
import { addTrigger } from './addTrigger';
import { client } from '../../config/apollo/client';
import { isWeb } from '../../config/designSystem/Layout';


export const setOneSignalUser = async (decodedData : any, lang:string, redirectTowardsReckoning?: boolean, register?: boolean) => {
  if(isWeb) {
    setOneSignalUserWeb(decodedData, lang,redirectTowardsReckoning, register);
  } else {
    setOneSignalUserMobile(decodedData, lang,redirectTowardsReckoning, register);
  }
};

export const setOneSignalUserMobile = async (decodedData : any, lang:string, redirectTowardsReckoning?: boolean, register?: boolean) => {
  try {
    let tags : any = {
      'name': decodedData.firstName.trim(),
      'company_id': decodedData.company,
      'company_name': decodedData.companyName,
      'withAssistance': decodedData?.withAssistance ? 'true': 'false'};
    if(register) {
      tags = {...tags,
        'has_registered': 'true',
        'evolutime': 'false',
        'number_of_path_started': '0',
        'number_of_path_completed': '0'};
    }



    OneSignal.login(decodedData._id);

    addTagsMobile(tags);

    OneSignal.User.addEmail(decodedData.email);

    OneSignal.User.setLanguage(lang);

    if(register) {
      if(redirectTowardsReckoning) {
        addTrigger('has_registered_with_redirect_towards_reckoning', lang);
      } else {
        if(decodedData?.withAssistance) {
          addTrigger('has_registered', lang);
        } else {
          addTrigger('has_registered_no_assistance', lang);
        }
      }
    }
  } catch(error) {
    console.log('error',error);
  }

};

const setOneSignalUserWeb =  async (decodedData : any, lang:string, redirectTowardsReckoning?: boolean, register?: boolean) => {
  let tags : any = {
    'name': decodedData.firstName.trim(),
    'company_id': decodedData.company,
    'company_name': decodedData.companyName,
    'withAssistance': decodedData?.withAssistance};

  if(register) {
    tags = {...tags,
      'has_registered': 'true',
      'evolutime': 'false',
      'number_of_path_started': '0',
      'number_of_path_completed': '0'};
  }
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  try {

    const currentDate = Math.round(Number(new Date())/1000);

    if(register) {
      client.mutate({
        mutation: CREATE_ONE_SIGNAL_USER,
        variables:{
          body: JSON.stringify({
            properties: {
              tags,
              language: lang,
              timezone_id: timeZone,
              first_active: currentDate,
              last_active: currentDate
            },
            identity: {external_id: decodedData?._id},
            subscriptions: [
              {
                type: 'Email',
                token: decodedData?.email,
                enabled: true,
                device_model: navigator.userAgent,
                device_os: navigator?.platform,
              }
            ]
          })
        }
      });


    } else {
      client.mutate({
        mutation: ADD_ONE_SIGNAL_TAGS,
        variables:{
          body: JSON.stringify({
            properties: {
              tags,
              language: lang,
              timezone_id: timeZone,
              last_active: currentDate
            },
            deltas: {session_count: 1}
          })
        }
      });
    }

  } catch(error){
    console.log('error',error);
  }};

